import { render, staticRenderFns } from "./SkillsTraining.vue?vue&type=template&id=89964f3a&scoped=true"
import script from "./SkillsTraining.vue?vue&type=script&lang=js"
export * from "./SkillsTraining.vue?vue&type=script&lang=js"
import style0 from "./SkillsTraining.vue?vue&type=style&index=0&id=89964f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89964f3a",
  null
  
)

export default component.exports